import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FaChevronDown, FaXmark } from "react-icons/fa6";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import styles from "../../styles/patient-page-modules/Chatbot.module.css";

/**
 * Reference surface for the CCM quick actions (Condition Guidelines /
 * Red-Flag Warning Signs).
 */
const CcmReferenceDrawer = ({ result, pendingAction, pendingLabel }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  // A new lookup always brings the drawer back, however it was left.
  useEffect(() => {
    if (!pendingAction) return;
    setIsClosed(false);
    setIsCollapsed(false);
  }, [pendingAction]);

  if (isClosed) return null;
  if (!pendingAction && !result) return null;

  const isLoading = !!pendingAction;
  const action = pendingAction || result?.action;
  const title = (isLoading ? pendingLabel : result?.label) || "Reference";
  const isWarning = action === "warning-signs";

  return (
    <div
      className={`${styles.referenceDrawer} ${
        isWarning ? styles.referenceDrawerWarning : ""
      }`}
    >
      <div className={styles.referenceHeader}>
        {/* The whole title area toggles collapse — an 11px chevron alone is a
            miserable hit box. */}
        <button
          type="button"
          className={styles.referenceCollapseBtn}
          onClick={() => setIsCollapsed((prev) => !prev)}
          aria-expanded={!isCollapsed}
          aria-label={isCollapsed ? "Expand reference" : "Collapse reference"}
        >
          <FaChevronDown
            className={`${styles.referenceChevron} ${
              isCollapsed ? styles.referenceChevronCollapsed : ""
            }`}
          />
          <span className={styles.referenceTitle}>{title}</span>
          {isCollapsed && result?.summary && (
            <span className={styles.referenceSummary}>· {result.summary}</span>
          )}
        </button>

        <button
          type="button"
          className={styles.referenceIconBtn}
          onClick={() => setIsClosed(true)}
          title="Close"
          aria-label="Close reference"
        >
          <FaXmark />
        </button>
      </div>

      {!isCollapsed && (
        <div
          className={`${styles.referenceBody} ${
            isWarning ? styles.referenceBodyWarning : ""
          }`}
        >
          {isLoading ? (
            <FontAwesomeIcon icon={faCircle} className={styles.blinking_loader} />
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {result?.text?.trim()}
            </ReactMarkdown>
          )}
        </div>
      )}
    </div>
  );
};

export default CcmReferenceDrawer;
